import { memo, useMemo } from "react";
import logoDesktop from "@images/v2/logo.svg";
import { Link } from "gatsby";
import cc from "classcat";
import { isFunction } from "lodash";

const Logo = memo(({ onBoarding = false, isClickable = true, className = "", ...props }) => {
	const LinkComponent = useMemo(() => {
		if (isClickable) {
			return Link;
		}

		return ({ to, children, ...props }) => <span {...props}>{children}</span>;
	}, [isClickable]);

	return (
		<div id="logo" className={cc(["logo-container", className])} {...props}>
			<LinkComponent
				to="/"
				onClick={(e) => {
					if (!isClickable) {
						e.preventDefault();
					}
				}}
				className={cc({ "cursor-default": !isClickable && !isFunction(props.onClick) })}
			>
				<img
					src={logoDesktop}
					style={{
						width: 173,
						height: 29,
					}}
					className="align-middle"
					alt="Stay Nimble"
				/>
			</LinkComponent>
		</div>
	);
});

export default Logo;
